module.exports = __webpack_public_path__ + "img/protecting.56c19b2f.png";